import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { useLayoutContext } from '@/contexts';
import { Carousel } from '@mantine/carousel';
import { Alert, Box, Button, Flex, Space, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { motion } from 'motion/react';
import { useState } from 'react';
import { ScanBlob } from '../assets/scan-blob';
import { ScanBlobOverlapped } from '../assets/scan-blob-overlapped';
import { ScanBlobPlastic } from '../assets/scan-blob-plastic';
import { useBagScanContext } from '../hook';
import styles from '../styles.module.css';

export const BagScanScanInstructionsPage = () => {
	const { isDesktop } = useLayoutContext();
	const { setShowCodeEntry, showCodeEntry, handleScan } = useBagScanContext();
	const [code, setCode] = useState('');
	const navigate = useNavigate();

	return (
		<Box>
			<MobileHeader title="Scan a Bag" onBack={() => navigate({ to: '/home' })} />
			<Flex
				px="lg"
				w="100%"
				flex={1}
				align="center"
				justify="center"
				direction="column"
				gap="lg"
				py="xl"
			>
				<motion.div
					initial={{ opacity: 0, y: 100 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -100 }}
					transition={{ duration: 0.5 }}
					className={styles.rootDiv}
				>
					<Carousel
						style={{ paddingTop: isDesktop ? 100 : 0 }}
						withIndicators
						withControls={false}
						height="100%"
						classNames={styles}
					>
						<Carousel.Slide>
							<Flex
								direction="column"
								maw="100hw"
								align="center"
								justify="center"
								h="100%"
								gap="md"
								p="lg"
							>
								<Space h={30} />
								<ScanBlobPlastic />
								<Text size="sm" fw="bold">
									Fill the bag with clean soft plastics only.
								</Text>
								<Alert
									icon={<IconAlertCircle />}
									title="DO NOT put these in the bag"
									variant="filled"
									bg="red"
								>
									<Text size="sm">
										Plastic bottles • plastic containers • rigid plastics • tin cans • glass •
										rubber • paper &amp; cardboard • toys • food waste
									</Text>
								</Alert>
							</Flex>
						</Carousel.Slide>
						<Carousel.Slide>
							<Flex direction="column" align="center" justify="center" h="100%" gap="md" p="xl">
								<ScanBlob />
								<Text size="sm" fw="bold" ta="center">
									When the bag is FULL (as possible), compress it and tightly tie with a double
									knot.
								</Text>
							</Flex>
						</Carousel.Slide>
						<Carousel.Slide>
							<Flex direction="column" align="center" justify="center" h="100%" gap="md" p="xl">
								<ScanBlobOverlapped />
								<Text size="sm" fw="bold" ta="center">
									Scan the QR code on the CurbyTag.
								</Text>
								<Text size="sm" ta="center">
									(We'll use your device camera)
								</Text>
							</Flex>
						</Carousel.Slide>
					</Carousel>
				</motion.div>
			</Flex>

			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={showCodeEntry}
				instructions="Please enter the code found on your Curby bag."
				onClose={() => {
					setCode('');
					setShowCodeEntry(false);
				}}
				shouldValidate
				actions={({ isValid, onClose }) => {
					return (
						<Flex w="100%" gap="sm">
							<Button fullWidth variant="filled" bg="grey" c="white" onClick={onClose}>
								Close
							</Button>
							<Button
								fullWidth
								disabled={!isValid}
								variant="filled"
								onClick={() => handleScan(code)}
							>
								Submit
							</Button>
						</Flex>
					);
				}}
			/>
		</Box>
	);
};
